import React, { useState } from 'react';

import { Box, IconButton, Button } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import ApiServices from 'services';
import { ModalFormDetail } from 'components';

import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

const ServiceMainItem = ({
  clientCompanyId,
  dataItem,
  subServiceListFormat = [],
  subServiceActive = [],
  reloadData,
  serParentList = [],
}) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [serIdDeleteList, setSerIdDeleteList] = useState([]);

  const handleClickOpenConfirm = (serIds) => {
    if (serIds?.length <= 0) return;
    setSerIdDeleteList(serIds);
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setSerIdDeleteList([]);
    setOpenConfirm(false);
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const handleAddSubSer = async (serviceId) => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await ApiServices.updateUpdateServiceCC(clientCompanyId, {
        idsToAdd: [serviceId],
      });
      if (res.status === 200) {
        reloadData();
        window.UIMessage?.success('Cập nhật thành công');
      }
    } catch (error) {
      window.UIMessage?.error('Cập nhật thất bại !!!');
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteSubSer = async (serviceId) => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await ApiServices.updateUpdateServiceCC(clientCompanyId, {
        idsToRemove: [serviceId],
      });
      if (res.status === 200) {
        reloadData();
        window.UIMessage?.success('Cập nhật thành công');
      }
    } catch (error) {
      window.UIMessage?.error('Cập nhật thất bại !!!');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMainSer = async (serviceIdList) => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await ApiServices.updateUpdateServiceCC(clientCompanyId, {
        idsToRemove: serviceIdList,
      });
      if (res.status === 200) {
        reloadData();
        window.UIMessage?.success('Xóa thành công');
      }
    } catch (error) {
      window.UIMessage?.error('Xóa thất bại !!!');
    } finally {
      setLoading(false);
      handleCloseConfirm();
    }
  };

  const handleChangeSubSer = (serId, isAdd = false) => {
    if (isAdd) {
      return handleDeleteSubSer(serId);
    }
    return handleAddSubSer(serId);
  };

  const renderSubservice = (sub, ind) => {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 0,
        }}
      >
        <IconButton
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 3,
            padding: 0,
          }}
          color={sub?.isSelected ? 'primary' : 'default'}
          size="small"
          onClick={() => handleChangeSubSer(sub?.id, sub?.isSelected)}
        >
          {sub?.isSelected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        </IconButton>
        <p style={{ flex: 1, margin: 2, paddingLeft: 2 }}>{sub?.name || sub?.code}</p>
      </Box>
    );
  };

  return (
    <Box>
      <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <IconButton onClick={handleClick}>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
        <Box style={{ flex: 1 }}>
          {dataItem?.name || dataItem?.code}
          <b>
            {' '}
            (<b style={{ color: 'red' }}>{subServiceActive?.length}</b>
            {`/${subServiceListFormat?.length}`})
          </b>
        </Box>
        <IconButton
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          color="error"
          size="small"
          disabled={serParentList?.length < 2}
          // onClick={() => handleDeleteMainSer([dataItem?.id, ...subServiceActive])}
          onClick={() => handleClickOpenConfirm([dataItem?.id, ...subServiceActive])}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
      <Box
        style={{
          maxHeight: 300,
          overflow: 'auto',
        }}
      >
        <Collapse in={open} timeout="auto" unmountOnExit>
          {subServiceListFormat?.map(renderSubservice)}
        </Collapse>
      </Box>

      <ModalFormDetail
        maxWidth="xs"
        open={openConfirm}
        onCloseModal={handleCloseConfirm}
        title="Bạn có chắc chắn xóa?"
      >
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box
            style={{
              marginLeft: 'auto',
            }}
          >
            <Button onClick={handleCloseConfirm} color="error">
              Hủy
            </Button>
            <Button onClick={() => handleDeleteMainSer(serIdDeleteList)} color="primary" autoFocus>
              Đồng Ý
            </Button>
          </Box>
        </Box>
      </ModalFormDetail>
    </Box>
  );
};

export { ServiceMainItem };
